"use client";
import React, { useEffect, useState } from "react";
import styles from "./Satisfy.module.scss";
import SvgStart from "@/app/icons/SvgStar.svg";
import { Message, MessageType } from "@/app/store/types";
import SemiButton from "@/app/ui/button";
import { addRecord } from "@/app/api/message";
import { ScrollAction, ScrollFrom } from "@/app/hooks/useReadScrollToBottom";
import { useTranslations } from "@/app/locales";
import { webSocketService } from "@/app/services/WebSocketService";
import { tryParse } from "@/app/utils/object";

interface IProps {
  msg: Message;
  isResult?: boolean;
}
export default function Satisfy(props: IProps) {
  const t = useTranslations();
  const [isResolved, setIsResolved] = useState<boolean | null>(null);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);
  const [commended, setCommended] = useState<boolean>(false);
  const handleSubmit = async () => {
    try {
      setLoading(true);
      const conversationId = props.msg.conversationId;
      if (conversationId) {
        await addRecord({
          content: comment,
          conversationId: conversationId,
          resolved: isResolved as boolean,
          satisfaction: rating,
        });
        // 满意度消息来源可能是坐席主动推送，或者用户发送
        webSocketService.sendMessage(
          `{"text":"${t.systemMsg.satisfyComment}"}`,
          {
            msgType: MessageType.Template,
            noNeedSendToWebsocket: true,
          },
        );
        setCommended(true);
      }
    } catch {}

    setLoading(false);
  };

  useEffect(() => {
    if (!props.msg.disabled) {
      // 新进来的满意度才滚动到底部，历史消息不滚动到底部
      props.msg.handleScrollToBottom?.(
        ScrollAction.FORCE_TO_BOTTOM,
        ScrollFrom.SATISFY,
      );
    }
    if (props.msg.disabled) {
      const parseData = tryParse(props.msg.content);
      if (parseData) {
        setIsResolved(parseData.isSolve);
        setRating(parseData.score);
        setComment(parseData.evaluate);
        setCommended(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const MAX_LENGTH = 500;
  return (
    <div
      className={`${styles.feedbackContainer} ${commended ? styles.commended : ""}`}
    >
      <h2 className={styles.title}>{t.chat.questionSolved}</h2>
      <div className={styles.resolutionOptions}>
        <button
          autoFocus={false}
          className={`${styles.resolved} ${styles.resolutionBtn} ${isResolved === true ? styles.resolutionActive : ""}`}
          onClick={() => setIsResolved(true)}
          disabled={commended}
        >
          {t.chat.solved}
        </button>
        <button
          autoFocus={false}
          className={`${styles.unResolved} ${styles.resolutionBtn} ${isResolved === false ? styles.resolutionActive : ""}`}
          onClick={() => setIsResolved(false)}
          disabled={commended}
        >
          {t.chat.unSolved}
        </button>
      </div>

      <div className={styles.ratingSection}>
        <p className={styles.ratingTitle}>{t.chat.satisfyTitle}</p>

        <div className={styles.starRating}>
          {[...Array(5)].map((_, index) => (
            <button
              key={index}
              type="button"
              className={`${styles.star} ${index < rating ? styles.starActive : ""}`}
              onClick={() => setRating(index + 1)}
              aria-label={`${index + 1} level`}
              disabled={commended}
            >
              <SvgStart />
            </button>
          ))}
        </div>

        <textarea
          className={styles.commentBox}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder={t.chat.satisfyPlaceholder}
          rows={3}
          maxLength={MAX_LENGTH}
          disabled={commended}
        />
      </div>
      <SemiButton
        onClick={() => handleSubmit()}
        className={styles.submitBtn}
        disabled={isResolved === null || rating === 0 || commended}
        loading={loading}
      >
        {t.button.submit}
      </SemiButton>
    </div>
  );
}
